import { OrderedMap } from 'immutable';

export const NAMESPACE = 'archives-query';

export const DATE_FILTER = 'date';
export const TEAM_FILTER = 'teams';
export const STATUS_FILTER = 'status';
export const SEARCH_DISPLAY_DATE_FORMAT = 'yyyy-MM-dd';
export const ALLOWED_PHRASES_BUT_NOT_FILTERS = ['name', 'text'];
export const FILTERS_MAP = OrderedMap({
  [STATUS_FILTER]: 'Status',
  builds: 'Build',
  tags: 'Tag',
  platforms: 'Platform',
  browsers: 'Browser',
  owners: 'Owner',
});

export const XTM_FILTERS_MAP = OrderedMap({
  [TEAM_FILTER]: 'Teams',
});

export const FILTERS_NO_SHARING_MAP = OrderedMap({
  [STATUS_FILTER]: 'Status',
  builds: 'Build',
  tags: 'Tag',
  platforms: 'Platform',
  browsers: 'Browser',
});

export const XTM_NO_SHARING_FILTERS_MAP = OrderedMap({
  owners: 'Owner',
  [TEAM_FILTER]: 'Teams',
});
